import TablePagination from './src/main';

TablePagination.install = function (Vue) {
  Vue.component(TablePagination.name, TablePagination);
}

export default TablePagination;
